import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

// 会议相关
const conferences = new Restful(project, 'conferences')

conferences.released = function(id, data) {
  const url = project + 'conferences/released/' + id
  return http.put(url, data).then(res => {
    return res
  })
}

export default conferences
